import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_11db373e: FaireBrandEntity = {
  token: "b_11db373e",
  type: "brand",
  name: "Idlewild Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/e7cafecd17580a2e581fb1a72fa050396927cc991b3589758ef337ac0c4c682e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/df228c0f5bafcdfde75a10f79872d5dd7c4d9f07b51bd43bbc71d45151112eea.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e7cafecd17580a2e581fb1a72fa050396927cc991b3589758ef337ac0c4c682e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/df228c0f5bafcdfde75a10f79872d5dd7c4d9f07b51bd43bbc71d45151112eea.jpeg",
  location: "Vero Beach, FL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 360,
  isTopShop: true,
  isInsider: true,
  description:
    "Idlewild Co. is a boutique paper goods & gift company founded in 2010 by artist & designer, Katie Gastley.  What would become a nationally distributed stationery line began with a tiny pop-up at the Renegade Craft Festival in McCarren Park, Brooklyn. A few shoppers noticed her whimsically hand-painted Brooklyn neighborhood prints and asked if Katie would create wedding stationery based on the artwork- and shortly thereafter she was working on her first commissioned invitations. With a robust collection of hand-painted wedding suites under her belt, she expanded her work into a line of greeting cards and hand-bound notebooks that debuted at the National Stationery Show. In a few short years the brand has established itself as a go-to independent source for creative gift products, selling through hundreds of stores across the globe. In 2013 Idlewild Co. relocated to the sunny shores of Vero Beach, Florida, where the team operates from today.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:06.103Z",
    importedBy: "entity-db-cli",
  },
};
